module.exports = __webpack_public_path__ + "img/preview-5.4532477a.webp";